import { useTranslation } from "react-i18next";
import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

export default function Page500() {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const backHomeFnc = () => {
    navigate(-1)
  }

  return (
    <Result
      status="500"
      title="500"
      subTitle={t("Sorry, something went wrong.", "Sorry, something went wrong.")}
      extra={<Button onClick={backHomeFnc} type="primary">{t("Quay về trang chủ", "Quay về trang chủ")}</Button>}
    />
  )
}
